/* =====================================================================
   SPLENDIDO JOURNAL — Editorial template enhancer (~2kb)
   - Assigns slug IDs to body H2/H3
   - Builds Table of Contents (desktop + mobile share the same list markup)
   - Single IntersectionObserver for active-section highlight
   NO MutationObserver. NO external deps. Smooth-scroll is CSS-only.
   ===================================================================== */
(function () {
  "use strict";

  function slugify(s) {
    return (s || "")
      .toLowerCase()
      .replace(/[ä]/g, "ae").replace(/[ö]/g, "oe").replace(/[ü]/g, "ue").replace(/[ß]/g, "ss")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 60) || "abschnitt";
  }

  function init() {
    var content = document.querySelector("[data-editorial-content]");
    if (!content) return;

    var headings = content.querySelectorAll("h2, h3");
    if (!headings.length) return;

    var used = {};
    var items = [];
    headings.forEach(function (h) {
      var base = h.id || slugify(h.textContent);
      var id = base, n = 2;
      while (used[id]) { id = base + "-" + n; n++; }
      used[id] = true;
      h.id = id;
      items.push({ id: id, text: h.textContent.trim(), sub: h.tagName === "H3" });
    });

    // Build TOC lists (there can be a desktop + a mobile container)
    var lists = document.querySelectorAll("[data-editorial-toc-list]");
    if (lists.length) {
      var html = items.map(function (it) {
        return '<li><a class="' + (it.sub ? "is-sub" : "") + '" href="#' + it.id + '">' + escapeHtml(it.text) + "</a></li>";
      }).join("");
      lists.forEach(function (ul) { ul.innerHTML = html; });
    }

    // Active-state via a single IntersectionObserver
    var links = document.querySelectorAll('[data-editorial-toc-list] a');
    if (!links.length || !("IntersectionObserver" in window)) return;

    function setActive(id) {
      links.forEach(function (a) {
        a.classList.toggle("is-active", a.getAttribute("href") === "#" + id);
      });
    }

    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
      // pick the first heading (document order) currently visible
      for (var i = 0; i < items.length; i++) {
        if (visible[items[i].id]) { setActive(items[i].id); break; }
      }
    }, { rootMargin: "-80px 0px -65% 0px", threshold: 0 });

    headings.forEach(function (h) { io.observe(h); });
  }

  function escapeHtml(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /* ---- Inline / CTA newsletter → Klaviyo client subscriptions (DOI) ---- */
  function initNewsletter() {
    var forms = document.querySelectorAll("[data-ed-news-form]");
    if (!forms.length) return;
    var MSG = (window.__edNewsMsg) || {
      ok: "Fast geschafft! Bitte bestätigen Sie Ihre Anmeldung in der E-Mail.",
      err: "Etwas ist schiefgelaufen. Bitte später erneut versuchen.",
      invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein."
    };
    forms.forEach(function (form) {
      var email = form.querySelector("[data-ed-news-email]");
      var gdpr = form.querySelector("[data-ed-news-gdpr]");
      var btn = form.querySelector("[data-ed-news-submit]");
      var box = form.parentNode.querySelector("[data-ed-news-msg]");
      var listId = form.getAttribute("data-list-id");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var val = (email.value || "").trim();
        if (!val || val.indexOf("@") === -1) { if (box) box.textContent = MSG.invalid; return; }
        if (gdpr && !gdpr.checked) {
          if (box) box.textContent = MSG.consent || "Bitte akzeptieren Sie die Datenschutzhinweise.";
          gdpr.focus();
          return;
        }
        if (btn) btn.disabled = true;
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=SaEb9w", {
          method: "POST",
          headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
          body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: "Editorial Journal", profile: { data: { type: "profile", attributes: { email: val } } } }, relationships: { list: { data: { type: "list", id: listId } } } } })
        }).then(function (r) {
          if (box) box.textContent = (r.status === 202 || r.ok) ? MSG.ok : MSG.err;
          if (r.status === 202 || r.ok) form.reset();
        }).catch(function () { if (box) box.textContent = MSG.err; })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  function boot() { init(); initNewsletter(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
